import { getEnumClientIdentityName       } from '../autogen/bundle.js';

import { getEnumSuspiciousActivityName   } from '../autogen/bundle.js';
import { getEnumSuspiciousActivityValues } from '../autogen/bundle.js';

import { isStringSpecified } from '../util';
import { parseUint32 } from '../util';
import { isRoleModeratorOrAdmin } from '../util';

//-----------------------------------------------------------------------------

// NOTE: see EnumClientIdentity
export const CLIENT_IDENTITY_TYPE_EXT_ID = 1;
export const CLIENT_IDENTITY_TYPE_DEVICE = 2;
export const CLIENT_IDENTITY_TYPE_FB     = 3;
export const CLIENT_IDENTITY_TYPE_GPLAY  = 4;
export const CLIENT_IDENTITY_TYPE_APPLE  = 5;

export function getClientIdentityTypes() {
  return [
    CLIENT_IDENTITY_TYPE_EXT_ID,
    CLIENT_IDENTITY_TYPE_DEVICE,
    CLIENT_IDENTITY_TYPE_FB,
    CLIENT_IDENTITY_TYPE_GPLAY,
    CLIENT_IDENTITY_TYPE_APPLE,
  ];
}

export function getClientIdentityTypeName(code) {
  switch(code) {
    case 1: return 'Ext id';
    case 2: return 'Device id';
    case 3: return 'Facebook id';
    case 4: return 'Google id';
    case 5: return 'Apple id';
  }
  return getEnumClientIdentityName(code);
}

//-----------------------------------------------------------------------------

/**
 * @typedef {number} PlayerStatus
 */

export const PLAYER_STATUS_UNKNOWN                 = 0
export const PLAYER_STATUS_EXIST                   = 1
export const PLAYER_STATUS_DELETED_BY_REQUEST      = 2
export const PLAYER_STATUS_DELETED_BY_INSIDER_USER = 3

/**
 * @param {PlayerStatus} status
 * @returns {boolean}
 */
export function isPlayerExist(status) {
  return status === PLAYER_STATUS_EXIST;
}

/**
 * @param {PlayerStatus} status
 * @returns {boolean}
 */
export function isPlayerDeletedByRequest(status) {
  return status === PLAYER_STATUS_DELETED_BY_REQUEST;
}

/**
 * @param {PlayerStatus} status
 * @returns {boolean}
 */
export function isPlayerDeletedByInsiderUser(status) {
  return status === PLAYER_STATUS_DELETED_BY_INSIDER_USER;
}

//-----------------------------------------------------------------------------

export function parsePlayersIdsDelimitedByComma(str) {
  if(!isStringSpecified(str)) {
    const emptyResult = {
      playersIds: [],
      error: null,
    };
    return emptyResult;
  }

  const parts = str.split(',');

  const playersIds = [];
  for(const part of parts) {
    const parsingResult = parsePlayerId(part);
    if(parsingResult.error !== null) {
      return {
        playersIds: null,
        error: parsingResult.error,
      };
    }
    playersIds.push(parsingResult.playerId);
  }

  return {
    playersIds: playersIds,
    error: null,
  };
}

export function parseUniquePlayersIdsDelimitedByComma(str) {
  if(!isStringSpecified(str)) {
    const emptyResult = {
      playersIds: [],
      error: null,
    };
    return emptyResult;
  }

  const parts = str.split(',');

  const playersIds = [];
  for(const part of parts) {
    const parsingResult = parsePlayerId(part);
    if(parsingResult.error !== null) {
      return {
        playersIds: null,
        error: parsingResult.error,
      };
    }
    playersIds.push(parsingResult.playerId);
  }

  const duplicates = findDuplicates(playersIds);
  if(duplicates.length > 0) {
    return {
      playersIds: null,
      error: new Error('Duplicates of players ids: ' + duplicates.join(', ') + '.'),
    };
  }

  return {
    playersIds: playersIds,
    error: null,
  };
}

function parsePlayerId(playerIdStr) {
  const playerIdStrTrimmed = playerIdStr.trim();
  if(playerIdStrTrimmed.length === 0) {
    return {
      playerId: null,
      error: new Error('Player id length is 0.'),
    };
  }

  const playerId = parseUint32(playerIdStrTrimmed);
  if(playerId === null) {
    return {
      playerId: null,
      error: new Error(`String '${playerIdStrTrimmed}' is not valid player id. It is not uint32.`),
    };
  }

  return {
    playerId: playerId,
    error: null,
  };
}

function findDuplicates(ids) {
  const duplicates = [];

  const idsSet = new Set();
  for(const id of ids) {
    if(idsSet.has(id)) {
      if(duplicates.indexOf(id) === -1) {
        duplicates.push(id);
      }
    } else {
      idsSet.add(id);
    }
  }

  return duplicates;
}

export function getPlayerName(player) {
  if(playerHasName(player)) {
    return player.name;
  }
  return null;
}

export function playerHasName(player) {
  if(!('name' in player)) {
    return false;
  }

  const name = player.name;

  if(name === undefined) {
    return false;
  }
  if(name === null) {
    return false;
  }
  if(name.length === 0) {
    return false;
  }

  return true;
}

export function mayAddClientIdentity(role) {
  return isRoleModeratorOrAdmin(role);
}

export function mayDelClientIdentity(role) {
  return isRoleModeratorOrAdmin(role);
}

export function mayEditPlayerLevel(role) {
  return isRoleModeratorOrAdmin(role);
}

export function mayEditPlayerData(role) {
  return isRoleModeratorOrAdmin(role);
}

/**
 * @typedef {Object} PlayerInfo
 * @property {string} extId
 * @property {number} nstatsId
 */


/**
 * @param {number} suspicionsMask
 * @returns {string}
 */
export function getPlayerSuspiciousActivityStr(suspicionsMask) {
  if(suspicionsMask === 0) {
    return 'none';
  }
  
  var desciption = '';
  const possibleSuspicions = getEnumSuspiciousActivityValues();
  possibleSuspicions.forEach(suspicion => {
    if(suspicion & suspicionsMask) {
      desciption += getEnumSuspiciousActivityName(suspicion);
      desciption += ', ';
    }
  });

  desciption = desciption.slice(0, -2); // remove trailing comma
  return desciption;
}

/**
 * @param {number} mask
 * @returns {number[] | null}
 */
export function convertSuspiciousActivityMaskToList(mask) {
  if(mask === 0) {
    return null;
  }

  const suspiciousActivityList = [];

  const possibleSuspiciousActivity = getEnumSuspiciousActivityValues();
  for(const activity of possibleSuspiciousActivity) {
    if(activity & mask) {
      suspiciousActivityList.push(activity);
    }
  }

  return suspiciousActivityList;
}
